(() => {
  if (window.cilsonAtcLoaded) return;
  window.cilsonAtcLoaded = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const FMT = (n) => n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  let cartState = {}; // variantId -> { qty, key, lineQty }

  // Staffeln aus dem vorhandenen <script class="cil-tiers"> der Karte lesen
  const tiersFor = (el) => {
    if (el._tiers) return el._tiers;
    let t = [];
    const s = el.closest('.card-wrapper')?.querySelector('script.cil-tiers');
    if (s) {
      try {
        t = (JSON.parse(s.textContent).t || [])
          .filter((x) => x && x.min > 0 && x.p > 0)
          .sort((a, b) => a.min - b.min);
      } catch (e) {}
    }
    return (el._tiers = t);
  };

  const readCart = (cart) => {
    cartState = {};
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id);
      if (!cartState[id]) cartState[id] = { qty: 0, key: item.key, lineQty: item.quantity };
      cartState[id].qty += item.quantity;
    });
    renderAll();
  };

  const render = (el) => {
    const stepper = el.querySelector('.cilson-atc__stepper');
    if (!stepper) return;
    const qty = cartState[el.dataset.variantId]?.qty || 0;
    el.querySelector('.cilson-atc__add').hidden = qty > 0;
    stepper.hidden = qty === 0;
    const count = el.querySelector('.cilson-atc__count');
    if (count.textContent !== String(qty)) count.textContent = qty;
    el.classList.toggle('is-multi', qty > 1);
    el.querySelector('.cilson-atc__minus')
      .setAttribute('aria-label', qty > 1 ? 'Menge verringern' : 'Aus dem Warenkorb entfernen');

    const hint = el.querySelector('.cilson-atc__hint');
    const tiers = tiersFor(el);
    const next = tiers.find((t) => t.min > qty);
    const reached = [...tiers].reverse().find((t) => t.min <= qty);
    let html = '';
    if (qty > 0 && next) html = `Noch ${next.min - qty} St. bis <b>${FMT(next.p)} / St.</b>`;
    else if (qty > 0 && reached) html = `Staffelpreis <b>${FMT(reached.p)} / St.</b> aktiv`;
    if (hint.dataset.html !== html) { hint.innerHTML = html; hint.dataset.html = html; }
    hint.hidden = !html;
  };

  const renderAll = () => document.querySelectorAll('.cilson-atc[data-variant-id]').forEach(render);

  const post = async (url, body) => {
    const r = await fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await r.json();
    if (!r.ok) throw data;
    return data;
  };

  const refreshCart = async () => {
    const r = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
    readCart(await r.json());
  };

  // Warenkorb-Zähler im Header aktualisieren
  const refreshBubble = async () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    try {
      const r = await fetch(ROOT + '?sections=cart-icon-bubble');
      const html = (await r.json())['cart-icon-bubble'];
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (section) bubble.innerHTML = section.innerHTML;
    } catch (e) {}
  };

  const showError = (el, msg) => {
    el.querySelector('.cilson-atc__error')?.remove();
    const p = document.createElement('p');
    p.className = 'cilson-atc__error';
    p.textContent = msg || 'Menge konnte nicht geändert werden. Bitte erneut versuchen.';
    el.appendChild(p);
    setTimeout(() => p.remove(), 4000);
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.cilson-atc__add, .cilson-atc__plus, .cilson-atc__minus');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const el = btn.closest('.cilson-atc');
    const id = el.dataset.variantId;
    const s = cartState[id];

    el.classList.add('is-loading');
    try {
      if (btn.matches('.cilson-atc__minus')) {
        if (s) await post('cart/change.js', { id: s.key, quantity: Math.max(0, s.lineQty - 1) });
      } else {
        await post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
      }
      await refreshCart();
      refreshBubble();
      document.dispatchEvent(new CustomEvent('cilson:cart-updated', { detail: { variantId: id } }));
    } catch (err) {
      showError(el, err && err.description);
      refreshCart();
    } finally {
      el.classList.remove('is-loading');
    }
  });

  // Neu geladene Karten (Filter, Sortierung) mit dem Warenkorb abgleichen
  let raf;
  new MutationObserver((list) => {
    const fresh = list.some((m) => [...m.addedNodes].some((n) =>
      n.nodeType === 1 && !n.closest('.cilson-atc') &&
      (n.matches('.cilson-atc') || n.querySelector('.cilson-atc'))));
    if (!fresh) return;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(renderAll);
  }).observe(document.body, { childList: true, subtree: true });

  refreshCart();
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
})();
